import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Application } from '@domain/Application';
import { IdType } from '@domain/idType';
import { environment } from '@env/environment';

/**
 * Cliente de `applications-fn`.
 *
 * Todos los endpoints son POST con body, incluidos los de consulta: es el
 * estilo del backend actual y el rediseno no lo cambia.
 */
@Injectable({ providedIn: 'root' })
export class ApplicationService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiSolicitud;

  save(application: Application): Observable<unknown> {
    return this.http.post(`${this.base}/save`, application);
  }

  getById(id: string): Observable<unknown> {
    return this.http.post(`${this.base}/getApplicationById`, { id });
  }

  update(application: Application): Observable<unknown> {
    return this.http.post(`${this.base}/updateApplication`, application);
  }

  /** Ya existe una solicitud en tramite para esa identificacion. */
  validateApplicantById(idType: IdType, idNumber: string): Observable<unknown> {
    return this.http.post(`${this.base}/validateApplicantById`, { idType, idNumber });
  }

  /** Ya existe una matricula vigente para esa identificacion. */
  validateMembershipsById(idType: IdType, idNumber: string): Observable<unknown> {
    return this.http.post(`${this.base}/validateMembershipsById`, { idType, idNumber });
  }

  /** El alumno arrastra una migracion pendiente y debe renovar presencialmente. */
  validateMemberMigrationPendingById(idType: IdType, idNumber: string): Observable<unknown> {
    return this.http.post(`${this.base}/validateMemberMigrationPendingById`, { idType, idNumber });
  }

  memberById(idType: IdType, idNumber: string): Observable<unknown> {
    return this.http.post(`${this.base}/memberById`, { idType, idNumber });
  }

  membershipsById(membershipId: string): Observable<unknown> {
    return this.http.post(`${this.base}/membershipsById`, { membershipId });
  }

  availableCoursesById(membershipId: string): Observable<unknown> {
    return this.http.post(`${this.base}/availableGroups`, { membershipId });
  }

  /**
   * Identificaciones excluidas de la matricula digital.
   *
   * La lista vive hoy en `environment` y viaja en el bundle, con numeros de
   * documento reales. Esta anotado como observacion abierta en SPEC-001 y
   * requiere spec propia; no se cambia aqui.
   */
  validateBlacklistMember(idType: IdType, idNumber: string): boolean {
    return (environment.blacklistMembers ?? []).some(
      (member) => member.idType === idType && member.idNumber === idNumber,
    );
  }
}
